const state = {
  showModal: false,
  modalText: '',
};

const mutations = {
  setShowModal(localState, newShowModal) {
    localState.showModal = newShowModal;
  },
  setModalText(localState, newModalText) {
    localState.modalText = newModalText;
  },
};

const actions = {
  selectShowModal({ commit }, showModal) {
    commit('setShowModal', showModal);
  },
  selectModalText({ commit }, modalText) {
    commit('setModalText', modalText);
  },
};

export default {
  mutations,
  actions,
  state,
};
